import { Component } from '@angular/core';

@Component({
  selector: 'ct-dashboard-category-chart-widget',
  templateUrl: './dashboard-category-chart-widget.component.html',
  styleUrl: './dashboard-category-chart-widget.component.scss',
  standalone: false,
})
export class DashboardCategoryChartWidgetComponent {}
